<template>
  <component :is="component" v-bind="$props" />
</template>

<script>
import Loader from '@/components/ui-elements/Loader';
export default {
  name: 'Dashboard',
  components: {
    Loader,
    'mss-dashboard': () => ({
      component: import('@/components/dashboard/Home'),
      loading: Loader,
    }),
    'non-mss-dashboard': () => ({
      component: import('@/components/dashboard/NonSocietyHome'),
      loading: Loader,
    }),
  },
  computed: {
    component: function () {
      return this.$store.getters.userIsNonMSSUser
        ? 'non-mss-dashboard'
        : 'mss-dashboard';
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/variables_mixins.scss';

.home-page {
  .card-body {
    padding-bottom: 3em;

    .card-body {
      padding-bottom: 1em;
    }
  }
}

.resources__ebook {
  display: block;
  text-align: center;
  font-size: 1.25em;
  @include transition(all 0.3s);

  &:hover {
    text-decoration: none;
    color: lighten($link-color, 10%);

    img {
      opacity: 0.7;
    }
  }

  img {
    @include transition(all 0.3s);
    max-width: 180px;
    display: block;
    margin: 0 auto 10px auto;
    @include box-shadow(3px 3px 2px rgba(0, 0, 0, 0.3));
  }
}

.survey__due {
  text-transform: uppercase;
  color: #525252;
  font-size: 0.9rem;
}

.status__upgrade {
  margin-top: 1em;
  font-weight: bold;

  a {
    color: #000;
    display: block;

    &:hover {
      text-decoration: none;
      opacity: 0.7;
    }
  }

  img {
    display: block;
    max-width: 200px;
  }
}

.demographics__image {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 1em;
  max-width: 160px;
}

@media (min-width: 768px) {
  .status {
    .card-body {
      padding-bottom: 7rem;
    }
  }

  .status__upgrade {
    position: absolute;
    bottom: 1em;
  }

  .home {
    padding-left: 15px;
    padding-right: 15px;
  }
}

div[role='radiogroup']:focus {
  outline: none;
}

.video {
  max-width: 440px;
  margin: 0 auto;
  padding: 2em 0 2em 0;

  h3 {
    max-width: 320px;
    margin: 0 auto;
  }

  img {
    margin-bottom: 20px;
    @include box-shadow(0 0 20px 0 rgba(0, 0, 0, 0.2));
  }
}

.phairify-card {
  border: 2px solid rgba($phairify_primary_color_teal, 0.25);
  border-top: 0;

  .phairify-card-header {
    border-top: 2px solid rgba($phairify_primary_color_teal, 0);
    padding: 0 1em;
    background-color: rgba($phairify_primary_color_teal, 0.25);
    border-bottom: 2px solid rgba($phairify_primary_color_teal, 0);
  }

  .phairify-card-title {
    @include phairify_heading_not_bold_16;
  }

  .phairify-card-body {
    padding: 15px 15px 5px 40px;
  }
}

.material-design-icon.phairify-grey > .material-design-icon__svg {
  fill: $phairify_secondary_color_grey;
}

.material-design-icon.account-arrow-right-outline-icon {
  bottom: 0;

  & > .material-design-icon__svg {
    fill: $phairify_secondary_color_grey;
  }
}

.phairify-body-copy {
  @include phairify_body_copy;
}

.phairify-primary-teal {
  color: $phairify_primary_color_teal;
  border-bottom: 0;
}

.phairify-card-header__button {
  @include phairify_secondary_lime_button;
  border-radius: 0;
}

.phairify-hide-button {
  @include phairify_heading_bold_14;
  font-weight: 400;
  color: $phairify_secondary_color_grey;

  &.collapsed > .when-opened,
  &:not(.collapsed) > .when-closed {
    display: none;
  }

  &:focus {
    box-shadow: none;
  }
}

.phairify-card__deck {
  .phairify-card__group-box {
    margin: 0 8px;
  }
}

.phairify-card__group-box {
  position: relative;
  margin-top: 5px;
  box-shadow: none;
  border: 1px solid $phairify_v2_color_light_gray;
  border-radius: 0;

  .group-box__header {
    position: absolute;
    top: -1px;
    background: white;
    padding: 0 30px 0 10px;
    transform: translateY(-50%);

    h3 {
      @include phairify_heading_bold_16;
      color: $phairify_secondary_color_grey;
      display: inline-flex;
      margin-bottom: 0;
      font-weight: 700;
    }

    &--icon {
      top: -20px;
      padding-right: 20px;
    }

    .material-design-icon {
      margin-right: 20px;

      .material-design-icon__svg {
        fill: $phairify_secondary_color_grey;
      }
    }
  }

  .card-body {
    padding: 20px;
  }
}
</style>
